import cx from 'classnames'
import { useContext } from 'react'

import { LanguageContext } from '@lib/language'
import { getTextWithShippingDates } from '@lib/shipping'
import { SiteContext } from '@lib/site'

import Photo from '@components/photo'

interface CartAdditionalInfoProps {
  iconSize?: number
  className?: string
}

const CartAdditionalInfo = ({
  iconSize = 24,
  className,
}: CartAdditionalInfoProps) => {
  const { locale } = useContext(LanguageContext)
  const { cartSettings } = useContext(SiteContext)

  if (
    !cartSettings?.additionalInfo ||
    cartSettings.additionalInfo.length === 0
  ) {
    return null
  }

  return (
    <div
      className={cx(
        'flex flex-col p-5 gap-y-5 border border-gray-light rounded-md bg-gray-lightest',
        className,
      )}
    >
      {cartSettings?.additionalInfo?.map((item, index) => (
        <div
          key={`cart-additional-info-item-${index}`}
          className="flex items-start gap-x-2"
        >
          {!!item.icon && (
            <Photo
              image={item.icon}
              forceWidth={iconSize}
              forceHeight={iconSize}
              hasPlaceholder={false}
            />
          )}

          <div className="flex flex-col gap-y-1">
            <p className="leading-tight font-semibold text-base">
              {item.title}
            </p>
            {!!item.description && (
              <p
                dangerouslySetInnerHTML={{
                  __html: getTextWithShippingDates(
                    locale,
                    cartSettings,
                    item.description,
                  ),
                }}
                className="text-base"
              />
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default CartAdditionalInfo
